import { useEffect } from 'react'
import Layout from '../components/layout/Layout'
import './CookiePolicyPage.css'

const COOKIEBOT_ID = import.meta.env.VITE_COOKIEBOT_ID

function CookiePolicyPage() {
  useEffect(() => {
    const script = document.createElement('script')
    script.id = 'CookieDeclaration'
    script.src = `https://consent.cookiebot.com/${COOKIEBOT_ID}/cd.js`
    script.type = 'text/javascript'
    script.async = true

    const container = document.getElementById('cookie-container')
    if (container) {
      container.appendChild(script)
      return () => {
        if (container.contains(script)) {
          container.removeChild(script)
        }
      }
    }
  }, [])

  return (
    <Layout>
      <div className='cookie-policy'>
        <div className='cookie-policy-header'>
          <h1>Cookie Policy</h1>
          <p>
            For questions about our cookies and data practices, contact us at{' '}
            <a href='mailto:contact@cloudsoft.com.pl'>contact@cloudsoft.com.pl</a>
          </p>
        </div>
        <div id='cookie-container' className='cookie-policy-content' />
      </div>
    </Layout>
  )
}

export default CookiePolicyPage
